export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export const faqs: FaqItem[] = [
  {
    id: "faq-1",
    question: "看料档案里的「深挖」具体指什么？",
    answer:
      "我们把深挖定义为「把公开信息重新结构化的过程」：按时间线排列关键节点、标注每条信息的来源等级、指出其中的逻辑断点。它不是简单地把零散内容堆在一起，而是让事件骨架变得可见。",
  },
  {
    id: "faq-2",
    question: "网站内容的信息来源可靠吗？",
    answer:
      "所有内容基于公开信息整理，并在正文中区分三类信息：已公开可核实的信息、二手转述的信息、以及标注为待核实的推测。我们不会把推测写成结论，也欢迎读者指正任何需要修订的部分。",
  },
  {
    id: "faq-3",
    question: "专题会随着事件发展更新吗？",
    answer:
      "会。事件有后续时，对应的档案会持续更新，并在页面底部保留修订记录。更新的原则是「补充信息、修正错误、保留原判断」，而不是悄悄改写此前的结论。",
  },
  {
    id: "faq-4",
    question: "「舆情深挖」和普通的热点追踪有什么区别？",
    answer:
      "普通追踪关心发生了什么，舆情深挖关心的是「信息是怎么流动的」。我们会记录一条信息在跨平台传播中丢失了哪些限定条件、在哪个节点被加入了情绪，以及讨论最终是如何转向的。",
  },
  {
    id: "faq-5",
    question: "可以在看料档案投稿或提供线索吗？",
    answer:
      "可以。我们欢迎有具体时间线与可核实节点的线索。你可以通过页脚的订阅表单留下联系方式与简要说明，编辑团队会在核实后与你联系。我们不处理缺乏事实基础的匿名指控。",
  },
  {
    id: "faq-6",
    question: "订阅之后会收到什么内容？",
    answer:
      "订阅后你会在每周收到一封深度内容摘要，包含本周更新的专题、被最多读者反复阅读的旧档案，以及一份「本周值得留意的信息流向」简报。随时可以取消。",
  },
];